{
  "familyId": "GET-KOMMA-VERGELIJK",
  "questions": [
    {
      "id": "GET-KOMMA-VERGELIJK-001",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welk getal is het grootst: 0,8 of 0,53?",
      "context": null,
      "options": ["0,8", "0,53", "ze zijn gelijk", "dat kun je niet vergelijken"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 0, "end": 1, "marked": [0.53], "step": 0.1, "label": "0,53 op de getallenlijn — waar komt 0,80?" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Kommagetallen vergelijken", "content": "Maak het aantal cijfers achter de komma gelijk door een nul toe te voegen. 0,8 = 0,80. Vergelijk nu: 80 honderdsten > 53 honderdsten. Dus 0,8 is groter.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_vergelijk_tienden_honderdsten",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Maak het aantal cijfers achter de komma gelijk: 0,8 = 0,80. Vergelijk nu: 0,80 en 0,53. 80 honderdsten is meer dan 53 honderdsten. Dus 0,8 > 0,53.",
        "solutionSteps": ["Maak het aantal cijfers gelijk: 0,8 = 0,80", "Vergelijk: 80 honderdsten en 53 honderdsten", "80 > 53, dus 0,8 > 0,53", "0,8 is het grootst"],
        "distractorExplanations": {
          "0": "Goed! 0,8 = 0,80 = 80 honderdsten. Dat is meer dan 0,53 = 53 honderdsten.",
          "1": "Je dacht waarschijnlijk dat meer cijfers achter de komma een groter getal betekent. Maar 0,53 = 53 honderdsten en 0,8 = 80 honderdsten. 80 > 53. Onthoud: voeg eerst een nul toe zodat je eerlijk vergelijkt.",
          "2": "Je dacht waarschijnlijk dat de getallen gelijk zijn. Maar 0,8 = 80 honderdsten en 0,53 = 53 honderdsten. 80 ≠ 53. Onthoud: maak het aantal cijfers achter de komma gelijk om te vergelijken.",
          "3": "Je dacht waarschijnlijk dat je kommagetallen niet kunt vergelijken. Maar dat kan wel: voeg nullen toe zodat beide getallen evenveel cijfers achter de komma hebben, en vergelijk dan. Onthoud: kommagetallen kun je altijd vergelijken."
        }
      }
    },
    {
      "id": "GET-KOMMA-VERGELIJK-002",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "multiple_choice",
      "question": "Zet in de juiste volgorde van klein naar groot: 1,5 — 1,05 — 1,50",
      "context": null,
      "options": ["1,05 — 1,5 — 1,50", "1,5 — 1,05 — 1,50", "1,50 — 1,05 — 1,5", "1,50 — 1,5 — 1,05"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 1, "end": 1.6, "marked": [1.05, 1.5], "step": 0.1, "label": "1,05 en 1,50 op de getallenlijn" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Gelijke nullen achter de komma", "content": "1,5 en 1,50 zijn precies gelijk — de extra nul verandert de waarde niet. 1,05 = 5 honderdsten, 1,50 = 50 honderdsten. 5 < 50, dus 1,05 is het kleinst.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_ordenen_gelijk",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.komma-meer-cijfers-groter", "label": "Denkt dat meer cijfers achter de komma = kleiner", "optionIndex": 1 },
          { "id": "get.komma-nul-aan-eind-telt", "label": "Denkt dat extra nul de waarde verandert", "optionIndex": 2 },
          { "id": "get.komma-volgorde-verwisseld", "label": "Volgorde van klein naar groot verwisseld", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Maak alle getallen even lang achter de komma: 1,5 = 1,50 en 1,05 = 1,05. Vergelijk: 1,05 heeft 5 honderdsten, 1,50 heeft 50 honderdsten. 1,05 is het kleinst. Let op: 1,5 en 1,50 zijn precies gelijk — de extra nul verandert de waarde niet. Volgorde: 1,05 — 1,5 — 1,50.",
        "solutionSteps": ["Maak gelijk: 1,5 = 1,50 en 1,05 = 1,05", "Vergelijk honderdsten: 05, 50, 50", "1,05 (5 honderdsten) is het kleinst", "1,5 en 1,50 zijn gelijk (allebei 50 honderdsten)", "Volgorde: 1,05 — 1,5 — 1,50"],
        "distractorExplanations": {
          "0": "Goed! 1,05 (5 honderdsten) is het kleinst. 1,5 en 1,50 zijn gelijk (allebei 50 honderdsten).",
          "1": "Je dacht waarschijnlijk dat 1,5 kleiner is dan 1,05 omdat 5 kleiner lijkt dan 05. Maar maak het gelijk: 1,5 = 1,50 = 50 honderdsten, en 1,05 = 5 honderdsten. 50 > 5. Onthoud: voeg eerst een nul toe zodat je eerlijk vergelijkt.",
          "2": "Je dacht waarschijnlijk dat 1,50 het kleinste getal is. Maar 1,50 = 1,5 — ze zijn gelijk. Het kleinste getal is 1,05. Onthoud: een extra nul achter de komma verandert de waarde niet.",
          "3": "Je dacht waarschijnlijk dat dit de volgorde van groot naar klein is. Maar de vraag vraagt van klein naar groot. Begin bij het kleinste getal: 1,05. Onthoud: lees goed of er 'klein naar groot' of 'groot naar klein' staat."
        }
      }
    },
    {
      "id": "GET-KOMMA-VERGELIJK-003",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welk teken hoort er: 2,45 ○ 2,5?",
      "context": null,
      "options": ["<", ">", "=", "≠"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 2.4, "end": 2.6, "marked": [2.45, 2.5], "step": 0.05, "label": "2,45 en 2,50 op de getallenlijn" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Vergelijkingstekens bij kommagetallen", "content": "Maak het aantal cijfers gelijk: 2,45 en 2,50. 45 honderdsten < 50 honderdsten. Dus 2,45 < 2,50. Het teken < wijst naar het kleinste getal.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_vergelijk_teken",
      "variantIndex": 3,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Maak het aantal cijfers achter de komma gelijk: 2,45 blijft 2,45 en 2,5 = 2,50. Vergelijk: 45 honderdsten < 50 honderdsten. Dus 2,45 < 2,50 → het teken is <.",
        "solutionSteps": ["Maak gelijk: 2,5 = 2,50", "Vergelijk: 2,45 en 2,50", "45 honderdsten < 50 honderdsten", "Dus 2,45 < 2,5 → teken is <"],
        "distractorExplanations": {
          "0": "Goed! 2,45 < 2,50 (= 2,5). 45 honderdsten is minder dan 50 honderdsten.",
          "1": "Je dacht waarschijnlijk dat 2,45 > 2,5 omdat 45 > 5. Maar je moet het aantal cijfers gelijk maken: 2,45 vs 2,50. Dan zie je: 45 < 50. Onthoud: voeg eerst een nul toe, dan vergelijk je eerlijk.",
          "2": "Je dacht waarschijnlijk dat de getallen gelijk zijn. Maar 2,45 = 245 honderdsten en 2,5 = 250 honderdsten. 245 ≠ 250. Onthoud: maak het aantal cijfers gelijk om te vergelijken.",
          "3": "Je dacht waarschijnlijk dat ≠ het juiste teken is. Het klopt dat de getallen niet gelijk zijn, maar de vraag vraagt naar het meest precieze teken. < geeft de exacte relatie aan: 2,45 is kleiner dan 2,5. Onthoud: gebruik < of > als je de richting kunt bepalen."
        }
      }
    },
    {
      "id": "GET-KOMMA-VERGELIJK-004",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welk getal ligt het dichtst bij 3?",
      "context": null,
      "options": ["2,95", "3,1", "2,8", "3,15"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 2.7, "end": 3.2, "marked": [2.8, 3, 3.1, 3.15], "step": 0.05, "label": "Vier getallen rond 3 — welk getal ontbreekt nog en ligt het dichtst bij 3?" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Afstand tot een getal berekenen", "content": "Bereken het verschil met 3 voor elk getal. Het getal met het kleinste verschil ligt het dichtst bij 3. 3 − 2,95 = 0,05 — dat is het kleinst!", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_dichtst_bij",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.69,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Bereken het verschil met 3 voor elk getal. 3 − 2,95 = 0,05. 3,1 − 3 = 0,1. 3 − 2,8 = 0,2. 3,15 − 3 = 0,15. Het kleinste verschil is 0,05, dus 2,95 ligt het dichtst bij 3.",
        "solutionSteps": ["Verschil 2,95: 3 − 2,95 = 0,05", "Verschil 3,1: 3,1 − 3 = 0,1", "Verschil 2,8: 3 − 2,8 = 0,2", "Verschil 3,15: 3,15 − 3 = 0,15", "Kleinste verschil: 0,05 → 2,95 ligt het dichtst bij 3"],
        "distractorExplanations": {
          "0": "Goed! 2,95 verschilt maar 0,05 van 3. Dat is het kleinste verschil van alle opties.",
          "1": "Je dacht waarschijnlijk dat 3,1 het dichtst bij 3 ligt omdat het boven 3 zit. Maar 3,1 verschilt 0,1 van 3, terwijl 2,95 maar 0,05 verschilt. Onthoud: het maakt niet uit of een getal boven of onder 3 ligt — het verschil telt.",
          "2": "Je dacht waarschijnlijk dat 2,8 dicht bij 3 ligt. Maar 2,8 verschilt 0,2 van 3 — dat is veel meer dan 0,05 (het verschil van 2,95). Onthoud: bereken het verschil om te vergelijken.",
          "3": "Je dacht waarschijnlijk dat 3,15 het dichtst bij 3 ligt. Maar 3,15 verschilt 0,15 van 3, terwijl 2,95 maar 0,05 verschilt. Onthoud: bereken het verschil voor elk getal en kies het kleinste."
        }
      }
    },
    {
      "id": "GET-KOMMA-VERGELIJK-005",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welk getal is het kleinst: 0,4 — 0,09 — 0,41 — 0,1?",
      "context": null,
      "options": ["0,09", "0,1", "0,4", "0,41"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 0, "end": 0.5, "marked": [0.1, 0.4, 0.41], "step": 0.1, "label": "Drie getallen — welk vierde getal ontbreekt en is het kleinst?" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Vergelijken met nullen", "content": "Maak alle getallen even lang: 0,40 — 0,09 — 0,41 — 0,10. Vergelijk de honderdsten: 40, 09, 41, 10. Het kleinste is 09 = 0,09.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_kleinste_vinden",
      "variantIndex": 5,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.komma-tienden-vs-honderdsten", "label": "Verwart tienden met honderdsten (1 < 9 zonder gelijk te maken)", "optionIndex": 1 },
          { "id": "get.komma-cijfers-direct-vergeleken", "label": "Cijfers achter de komma direct vergeleken zonder gelijk maken", "optionIndex": 2 },
          { "id": "get.komma-grootste-vs-kleinste", "label": "Grootste gekozen i.p.v. kleinste", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Maak alle getallen even lang achter de komma: 0,40 — 0,09 — 0,41 — 0,10. Vergelijk de honderdsten: 40, 09, 41, 10. Het kleinste getal is 09 honderdsten = 0,09.",
        "solutionSteps": ["Maak gelijk: 0,4 = 0,40; 0,09 = 0,09; 0,41 = 0,41; 0,1 = 0,10", "Vergelijk honderdsten: 40, 09, 41, 10", "Het kleinste is 09 honderdsten", "Dus 0,09 is het kleinste getal"],
        "distractorExplanations": {
          "0": "Goed! 0,09 = 9 honderdsten. Dat is kleiner dan 0,10 (10), 0,40 (40) en 0,41 (41 honderdsten).",
          "1": "Je dacht waarschijnlijk dat 0,1 kleiner is dan 0,09 omdat 1 < 9. Maar maak het gelijk: 0,10 = 10 honderdsten en 0,09 = 9 honderdsten. 10 > 9. Onthoud: voeg eerst een nul toe, dan vergelijk je eerlijk.",
          "2": "Je dacht waarschijnlijk dat 0,4 het kleinst is. Maar 0,4 = 0,40 = 40 honderdsten — dat is veel groter dan 0,09 = 9 honderdsten. Onthoud: maak het aantal cijfers gelijk om te vergelijken.",
          "3": "Je dacht waarschijnlijk dat 0,41 het kleinst is. Maar 0,41 = 41 honderdsten — dat is het grootste getal in de reeks. Onthoud: meer honderdsten = groter getal."
        }
      }
    },
    {
      "id": "GET-KOMMA-VERGELIJK-006",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "ordering",
      "question": "Zet deze kommagetallen van klein naar groot.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["0,7", "0,07", "0,71", "0,17"],
        "correctOrder": [1, 3, 0, 2]
      },
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 0, "end": 0.8, "marked": [0.07, 0.17, 0.7, 0.71], "step": 0.1, "label": "Alle getallen op de getallenlijn" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Kommagetallen ordenen", "content": "Maak alle getallen even lang achter de komma: 0,70 — 0,07 — 0,71 — 0,17. Vergelijk de honderdsten: 07, 17, 70, 71. Volgorde: 0,07 — 0,17 — 0,7 — 0,71.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_ordenen_interactive",
      "variantIndex": 6,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Maak alle getallen even lang: 0,70 — 0,07 — 0,71 — 0,17. Vergelijk de honderdsten: 07 < 17 < 70 < 71. Volgorde: 0,07 — 0,17 — 0,7 — 0,71.",
        "solutionSteps": [
          "Maak gelijk: 0,7 = 0,70; 0,07 = 0,07; 0,71 = 0,71; 0,17 = 0,17",
          "Vergelijk honderdsten: 07, 17, 70, 71",
          "Volgorde: 0,07 — 0,17 — 0,7 — 0,71"
        ]
      }
    },
    {
      "id": "GET-KOMMA-VERGELIJK-007",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "multiple_choice",
      "question": "In de winkel kost een pak koekjes €1,25 en een pak chips €1,4. Welk pak is duurder?",
      "context": null,
      "options": ["het pak chips", "het pak koekjes", "ze kosten evenveel", "dat kun je niet zien"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Geldbedragen vergelijken", "content": "Maak even lang: €1,25 en €1,40. Vergelijk de centen: 25 < 40. Dus €1,4 (= €1,40) is duurder dan €1,25.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_vergelijk_geld_context",
      "variantIndex": 7,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Maak de bedragen even lang: €1,25 en €1,40 (want €1,4 = €1,40). Vergelijk de centen: 40 cent > 25 cent. Dus het pak chips (€1,40) is duurder.",
        "solutionSteps": [
          "Maak gelijk: €1,4 = €1,40",
          "Vergelijk centen: 25 < 40",
          "€1,40 > €1,25 → pak chips is duurder"
        ],
        "distractorExplanations": {
          "0": "Goed! €1,40 > €1,25. Het pak chips is 15 cent duurder.",
          "1": "Je dacht waarschijnlijk dat €1,25 meer is omdat er meer cijfers achter de komma staan. Maar €1,4 = €1,40 = 140 cent, en €1,25 = 125 cent. 140 > 125.",
          "2": "De bedragen zijn niet gelijk: €1,25 = 125 cent en €1,4 = 140 cent. Verschil = 15 cent.",
          "3": "Je kunt geldbedragen altijd vergelijken — maak ze even lang en vergelijk de centen."
        }
      }
    },
    {
      "id": "GET-KOMMA-VERGELIJK-008",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welk teken hoort er: 0,6 ○ 0,60?",
      "context": null,
      "options": ["=", "<", ">", "≠"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 0, "end": 1, "marked": [0.6], "step": 0.1, "label": "0,6 en 0,60 staan op precies dezelfde plek" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Nul achter de komma", "content": "Een extra nul aan het einde van een kommagetal verandert de waarde niet. 0,6 = 6 tienden = 60 honderdsten = 0,60. Dus 0,6 = 0,60.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_vergelijk_gelijk_nul",
      "variantIndex": 8,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "0,6 betekent 6 tienden. 0,60 betekent 60 honderdsten = 6 tienden. Dus 0,6 = 0,60 — de extra nul aan het einde verandert de waarde niet.",
        "solutionSteps": [
          "0,6 = 6 tienden",
          "0,60 = 60 honderdsten = 6 tienden",
          "0,6 = 0,60 → teken is ="
        ],
        "distractorExplanations": {
          "0": "Goed! 0,6 = 0,60. Een extra nul aan het einde verandert de waarde niet.",
          "1": "Je dacht waarschijnlijk dat 0,6 kleiner is omdat er minder cijfers staan. Maar 0,6 = 0,60. Onthoud: een nul aan het einde verandert niets.",
          "2": "Je dacht waarschijnlijk dat 0,6 groter is. Maar 0,6 = 0,60 — ze zijn precies gelijk.",
          "3": "De getallen zijn juist gelijk: 0,6 = 0,60. Het teken ≠ klopt niet, want ze hebben dezelfde waarde."
        }
      }
    },
    {
      "id": "GET-KOMMA-VERGELIJK-CJ-001",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "comparison_judge",
      "question": "Bekijk elke uitspraak over kommagetallen: klopt deze of niet?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "comparisonJudge": {
          "criterion": "Welke vergelijking tussen kommagetallen klopt?",
          "items": [
            { "id": "A", "content": "0,7 > 0,68", "label": "0,7 is groter dan 0,68" },
            { "id": "B", "content": "0,25 > 0,3", "label": "0,25 is groter dan 0,3" },
            { "id": "C", "content": "0,09 > 0,1", "label": "0,09 is groter dan 0,1" }
          ],
          "correctIndex": 0
        }
      },
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetallen eerlijk vergelijken",
            "content": "Maak het aantal cijfers achter de komma gelijk door nullen toe te voegen. Vergelijk dan het hele getal achter de komma als honderdsten of duizendsten.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_vergelijk_judge",
      "variantIndex": 9,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Maak telkens het aantal cijfers gelijk. A: 0,7 = 0,70 > 0,68 ✓ KLOPT. B: 0,25 vs 0,30 → 0,25 < 0,30, dus 0,25 > 0,3 is FOUT. C: 0,09 vs 0,10 → 0,09 < 0,10, dus 0,09 > 0,1 is FOUT.",
        "solutionSteps": [
          "A: 0,7 = 0,70 → 70 honderdsten > 68 honderdsten ✓ klopt",
          "B: 0,25 = 25 honderdsten, 0,3 = 30 honderdsten → 25 < 30, dus B is fout",
          "C: 0,09 = 9 honderdsten, 0,1 = 10 honderdsten → 9 < 10, dus C is fout",
          "Alleen A klopt → antwoord = A"
        ]
      }
    }
  ]
}